import { Asterisk } from "lucide-react";
import { MARQUEE_ITEMS } from "../data/content";

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="group overflow-hidden border-y border-pine/10 bg-creamdeep py-6"
    >
      <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]">
        {[0, 1].map((copy) => (
          <div
            key={copy}
            aria-hidden={copy === 1}
            className="flex shrink-0 items-center"
          >
            {MARQUEE_ITEMS.map((item, i) => (
              <span
                key={i}
                className="flex items-center font-serif text-2xl md:text-3xl text-pine/70"
              >
                <span className="mx-7 whitespace-nowrap italic">{item}</span>
                <Asterisk className="h-5 w-5 text-terra/70" aria-hidden="true" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
